import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import api from "../../lib/api";

export const CHANNEL_HREF = "https://www.youtube.com/channel/UCs68SjdTp0KWzMEiKiHy1sw";

export const ytEmbed = (id) =>
  `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;

// Privacy-enhanced player: plays straight away, Cookiebot told to leave it alone.
export const YtFrame = ({ id, title, testid }) => (
  <iframe
    src={ytEmbed(id)}
    title={title}
    data-cookieconsent="ignore"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    referrerPolicy="strict-origin-when-cross-origin"
    allowFullScreen
    className="absolute inset-0 w-full h-full"
    style={{ border: 0 }}
    data-testid={testid}
  />
);

export const LatestVideoHero = () => {
  const [video, setVideo] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [thumb, setThumb] = useState("maxresdefault");

  useEffect(() => {
    api.get("/youtube/latest").then((r) => setVideo(r.data)).catch(() => setVideo(null));
  }, []);

  return (
    <section className="pt-[84px] sm:pt-[110px] pb-14 sm:pb-20" style={{ background: "#FFFFFF" }} data-testid="home-latest-video">
      <div className="max-w-[920px] mx-auto px-4 sm:px-8 flex flex-col items-center gap-8 sm:gap-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative w-full overflow-hidden"
          style={{ aspectRatio: "16/9", background: "#111", boxShadow: "0 30px 80px -30px rgba(0,0,0,0.35)" }}
        >
          {video && playing ? (
            <YtFrame id={video.video_id} title={video.title} testid="home-video-iframe" />
          ) : video ? (
            <button type="button" onClick={() => setPlaying(true)} className="group absolute inset-0 w-full h-full" aria-label="Guarda il video" data-testid="home-video-thumb">
              <img
                src={`https://i.ytimg.com/vi/${video.video_id}/${thumb}.jpg`}
                onError={() => setThumb("hqdefault")}
                alt={video.title}
                fetchpriority="high"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <span className="absolute inset-0" style={{ background: "rgba(0,0,0,0.18)" }} />
              <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110" style={{ background: "#FF2800" }}>
                <Play size={28} fill="#FFF" strokeWidth={0} className="ml-1" />
              </span>
            </button>
          ) : null}
        </motion.div>
        <HeroText video={video} onPlay={() => setPlaying(true)} />
      </div>
    </section>
  );
};

function HeroText({ video, onPlay }) {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.15 }} className="flex flex-col items-center text-center max-w-[860px]">
      <div className="flex items-center gap-3 mb-4 sm:mb-5">
        <span className="w-2 h-2 rounded-full animate-pulse" style={{ background: "#FF2800" }} />
        <span className="text-[11px] uppercase tracking-[0.3em]" style={{ color: "#8a8a8a", fontWeight: 500 }}>Ultimo video · YouTube</span>
      </div>
      <h1 className="text-2xl sm:text-4xl lg:text-5xl mb-8" style={{ color: "#111", fontWeight: 300, letterSpacing: "-0.02em", lineHeight: 1.12 }} data-testid="home-video-title">
        {video ? video.title : "Garage Drops"}
      </h1>
      <div className="flex flex-wrap items-center justify-center gap-3">
        {video ? (
          <button type="button" onClick={onPlay} className="inline-flex items-center gap-3 px-6 py-3.5 text-[14px] transition-transform duration-300 hover:scale-[1.03]" style={{ background: "#FF2800", color: "#FFF", fontWeight: 500 }} data-testid="home-video-play">
            <Play size={16} fill="#FFF" strokeWidth={0} /> Guarda il video
          </button>
        ) : null}
        <a href={CHANNEL_HREF} target="_blank" rel="noreferrer" className="inline-flex items-center px-6 py-3.5 text-[14px] transition-colors duration-300 hover:bg-black hover:text-white" style={{ color: "#111", border: "1px solid rgba(0,0,0,0.25)" }} data-testid="home-video-channel">
          Iscriviti al canale
        </a>
      </div>
    </motion.div>
  );
}
